<template>
    <LineChart
      id="my-chart-id"
      :options="chartOptions"
      :data="chartData"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>
<script>
    import { Line as LineChart } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement)

    export default {
        name: 'DashboardsalesChart',
        components: { LineChart },
        props: {
            chartData: {
                type: Object,
                required: true
            },
            chartOptions: {
            type: Object,
            default: () => {}
            },
            width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 180
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
  }
}
</script>